<template>
  <div class="main">
    <Result
      :icon="useAsset('img/credit-line/success_icon.png')"
      :title="t('CL_WITHDRAWAL.WITHDRAWAL_REQUEST_MSG')"
      :description="t('CL_WITHDRAWAL.WITHDRAWAL_REQUEST_DESCRIPTION')"
      :btn-text="t('CL_WITHDRAWAL.GO_TO_HOME_BTN')"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script setup lang="ts">
import Result from "@/apps/credit-line/components/Result.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { safeAndroidCall } from "@/apps/credit-line/helpers/safe-android-call.helper";

const { t } = useI18n();

function dismiss() {
  safeAndroidCall("confirmWithdrawal");
  safeAndroidCall("creditOfferAccepted");
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";
</style>
